import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { Camera } from '../types'
import { v4 as uuidv4 } from 'uuid'

const cameraSchema = (t: TFunction<'translation', undefined>) => {
  // @ts-ignore
  const objectSchema: yup.ObjectSchema<Camera> = yup.object({
    id: yup
      .string()
      .transform(id => {
        if (!id) return uuidv4()
        return id
      })
      .default(uuidv4())
      .required(),
    restaurantId: yup.string().required(t('errors.required')),
    serialNumber: yup.string().required(t('errors.required')),
    name: yup.string().required(t('errors.required')),
    type: yup.string().oneOf(['camera']).default('camera').required(),
  })

  return objectSchema
}

export default cameraSchema
